import { StageDef } from '../types';

/** 四阶段审查定义 */
export const STAGES: StageDef[] = [
    {
        id: 1,
        startAge: 22,
        endAge: 25,
        requiredRank: 3,   // Lv.3 圈内眼熟
        description: '阶段一（22-25岁）：达到Lv.3',
        // 未达标先演这条再终局（2026-10-21）：GameLoop.checkStagePass 只落「待演」标记，
        // 演出排干后由 GameLoop.resolvePendingStageFail 结算
        failEvent: 'FIXED_REVIEW_1_FAIL',
    },
    {
        id: 2,
        startAge: 25,
        endAge: 30,
        requiredRank: 6,   // Lv.6 二线艺人（2026-10-31 咖位重排顺移：保「30 岁二线」叙事语义）
        description: '阶段二（25-30岁）：达到Lv.6',
    },
    {
        id: 3,
        startAge: 30,
        endAge: 35,
        requiredRank: 8,   // Lv.8 顶流艺人（重排顺移：保「35 岁顶流」叙事语义）
        description: '阶段三（30-35岁）：达到Lv.8',
    },
    {
        id: 4,
        startAge: 35,
        endAge: 40,
        requiredRank: 0,  // 无审查，自由冲刺
        description: '阶段四（35-40岁）：无审查，自由冲刺',
    },
];